import moment from 'moment';
import { put, takeLatest } from 'redux-saga/effects';
import { createAppTableSaga, createAppTableStore } from 'components/AppTable/store';
import apiRoutes from 'config/apiRoute';
import { convertMinsToHrsMins } from 'utils/string.utils';
import { toTimeEntriesParams } from 'services/timeTracking/tableParams';
import { TimeEntriesMetrics } from 'services/timeTracking/types';

const startOfWeek = moment().startOf('week').format('YYYY-MM-DD');
const endOfWeek = moment().endOf('week').format('YYYY-MM-DD');

export const profileTimelogSlice = createAppTableStore({
  name: 'profileTimelog' as const,
  url: apiRoutes.TIME_ENTRIES,
  initialState: {
    params: {
      filters: {
        date_start: { value: startOfWeek },
        date_end: { value: endOfWeek },
        project_plan: [
          { value: 'starter' },
          { value: 'premium' },
          { value: 'enterprise' },
          { value: 'custom' },
          { value: 'hosting' },
        ],
        user_type: [{ value: 'regular_user' }, { value: 'freelancer' }],
        source: [],
        request_uuid: [],
      },
    },
    apiParamsHandler: toTimeEntriesParams,
    totalTime: null as null | string,
    metrics: null as null | TimeEntriesMetrics,
  },
  reducers: {
    setTotalTime: (state, { payload }: { payload: string }) => {
      state.totalTime = payload;
    },
    setMetrics: (state, { payload }: { payload: TimeEntriesMetrics | null }) => {
      state.metrics = payload;
    },
  },
});

function* handleApiResponseSagaListener({ payload }: { payload: any }) {
  yield put(profileTimelogSlice.actions.setTotalTime(convertMinsToHrsMins(Number(payload?.meta?.total_minutes ?? 0))));
  yield put(profileTimelogSlice.actions.setMetrics(payload?.meta?.metrics ?? null));
}

export const profileTimelogSaga = createAppTableSaga(profileTimelogSlice, function* customGenerator() {
  yield takeLatest(profileTimelogSlice.actions.handleApiResponse, handleApiResponseSagaListener);
});

export const profileTimelogReducer = profileTimelogSlice.reducer;
